export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10575.5c31bf8b.jpg";